module.exports = __webpack_public_path__ + "static/media/pending.20721efb.svg";